module.exports = __webpack_public_path__ + "static/media/b1.d6730d91.png";